/**
 * Uniba LoginButton reducer
 * @module src/reducers/unibaLoginButtonReducer
 */

import { GET_UNIBA_LOGINBUTTON } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const unibaLoginButtonReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UNIBA_LOGINBUTTON}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_UNIBA_LOGINBUTTON}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_UNIBA_LOGINBUTTON}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
